export interface SelectOption<T = number> {
  label: string;
  value: T;
  disabled?: boolean;
  selected?: boolean;
}

export interface SelectOptionWithId<T = number> extends SelectOption<T> { id: number }
export interface SelectOptionWithTooltip<T = number> extends SelectOption<T> { tooltip: string }

export type SelectOptions<T = number> = SelectOption<T>[];
export type SelectOptionsWithId<T = number> = SelectOptionWithId<T>[];
export type SelectOptionsWithTooltip<T = number> = SelectOptionWithTooltip<T>[];

export interface SetterCallback<T> {
  (value: T): void;
}

export interface PaginationResetCallback {
  (): void;
}

export type DateRange = [Date, Date];

export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

// These variables describe Bulma's responsive breakpoints
// Since there isn't a way to get SCSS variables from javascript
// in runtime we need to keep these values manually in sync with
// the breakpoints defined in this file: src/assets/utils/_variables.scss
// Bulma's docs: https://bulma.io/documentation/overview/responsiveness/#breakpoints
export enum BulmaBreakPoints {
  Mobile = 768,
  Tablet = 769,
  Desktop = 1024,
  Widescreen = 1216,
  FullHD = 1408,
}
